// CreateCourseDialog/index.js
import { connect } from 'react-redux';
import CreateCourseDialog from '../../components/CreateCourseDialog';

import {
  openCreateCourseDialogDispatch,
  onHandleInputChange,
  submitCourseDispatch,
  openDocumentListDialogDispatch,
  onDocumentSelectedForCourseDispatch
} from '../../actions';
import { submitMode } from '../../constants';

function mapStateToProps(state, ownProps) {
  return {
    openDialog: state.course.newCourse.showCreateCourseDialog,
    course: state.course.newCourse.item,
    documents: state.settings.allDocuments.itemsCopy,
    isSaving: state.course.newCourse.isSaving,
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    loggedInUser: state.users.user.item
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    openCreateCourseDialog: (open) => {
      dispatch(openCreateCourseDialogDispatch(open));
    },
    onHandleInputChange: (value, inputfieldName) => {
      dispatch(onHandleInputChange(value, inputfieldName));
    },
    submitCourse: (course) => {
      const mode = submitMode.CREATE;
      dispatch(submitCourseDispatch(course, mode));
    },
    openDocumentListDialog: (open) => {
      dispatch(openDocumentListDialogDispatch(open));
    },
    onDocumentSelected: (documentLink) => {
      dispatch(onDocumentSelectedForCourseDispatch(documentLink));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCourseDialog);
